import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { ISubscription } from "rxjs/Subscription";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "kl-loading",
  templateUrl: "./kl-loading.component.html",
  styleUrls: ["./kl-loading.component.scss"],
})
export class KlLoadingComponent implements OnInit, OnDestroy {
  private showSubscription: ISubscription;
  private hideSubscription: ISubscription;

  @Input() name: string;

  show: boolean;

  loadingText: string;

  constructor(
    private klLoadingService: KlLoadingService,
    private cd: ChangeDetectorRef
  ) {
    this.showSubscription = klLoadingService.loadingShowStream$.subscribe(
      (response) => {
        this.show = true;
        this.loadingText = response;
        this.cd.detectChanges();
      }
    );
    this.hideSubscription = klLoadingService.loadingHideStream$.subscribe(
      () => {
        this.loadingText = "";
        this.show = false;
        this.cd.detectChanges();
      }
    );
  }

  ngOnInit(): void {
    if (!this.cd["destroyed"]) {
      this.cd.detectChanges();
    }
  }

  ngOnDestroy() {
    this.showSubscription.unsubscribe();
    this.hideSubscription.unsubscribe();
  }
}
